import { AssertIsNumberException } from './assert-is-number.exception';
import { isNumber } from '@camino-solutions/utils/typeguard';

export function assertIsNumber(value: unknown): asserts value is number {
  if (!isNumber(value)) {
    throw new AssertIsNumberException(`Not a number: ${value}`);
  }
}
